export default __webpack_public_path__ + "static/media/dive_shot11.a968f175.png";